import { get } from "lodash";

export const selectUsers = (state) => get(state, "backOffice.users", []);
